import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import { ContextMenu } from '../ContextMenu/ContextMenu';
import { getValueFromDimension, getDisplayProcessor, dateTimeFormat, } from '@grafana/data';
import { useTheme } from '../../themes';
import { HorizontalGroup } from '../Layout/Layout';
import { FormattedValueDisplay } from '../FormattedValueDisplay/FormattedValueDisplay';
import { SeriesIcon } from '../VizLegend/SeriesIcon';
import { css } from 'emotion';
/** @internal */
export var GraphContextMenu = function (_a) {
    var getContextMenuSource = _a.getContextMenuSource, timeZone = _a.timeZone, items = _a.items, dimensions = _a.dimensions, contextDimensions = _a.contextDimensions, otherProps = __rest(_a, ["getContextMenuSource", "timeZone", "items", "dimensions", "contextDimensions"]);
    var source = getContextMenuSource();
    //  Do not render items that do not have label specified
    var itemsToRender = items
        ? items.map(function (group) { return (__assign(__assign({}, group), { items: group.items.filter(function (item) { return item.label; }) })); })
        : [];
    var renderHeader = function () {
        var _a, _b;
        if (!source) {
            return null;
        }
        // If dimensions supplied, we can calculate and display value
        var value;
        if ((dimensions === null || dimensions === void 0 ? void 0 : dimensions.yAxis) && ((_a = contextDimensions === null || contextDimensions === void 0 ? void 0 : contextDimensions.yAxis) === null || _a === void 0 ? void 0 : _a[1])) {
            var valueFromDimensions = getValueFromDimension(dimensions.yAxis, contextDimensions.yAxis[0], contextDimensions.yAxis[1]);
            var display = (_b = source.series.valueField.display) !== null && _b !== void 0 ? _b : getDisplayProcessor({
                field: source.series.valueField,
                timeZone: timeZone,
            });
            value = display(valueFromDimensions);
        }
        var formattedValue = dateTimeFormat(source.datapoint[0], {
            defaultWithMS: source.series.hasMsResolution,
            timeZone: timeZone,
        });
        return (React.createElement(GraphContextMenuHeader, { timestamp: formattedValue, seriesColor: source.series.color, displayName: source.series.alias || source.series.label, displayValue: value }));
    };
    return React.createElement(ContextMenu, __assign({}, otherProps, { items: itemsToRender, renderHeader: renderHeader }));
};
/** @internal */
export var GraphContextMenuHeader = function (_a) {
    var timestamp = _a.timestamp, seriesColor = _a.seriesColor, displayName = _a.displayName, displayValue = _a.displayValue;
    var theme = useTheme();
    return (React.createElement("div", { className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        padding: ", " ", ";\n        font-size: ", ";\n        z-index: ", ";\n      "], ["\n        padding: ", " ", ";\n        font-size: ", ";\n        z-index: ", ";\n      "])), theme.spacing.xs, theme.spacing.sm, theme.typography.size.sm, theme.zIndex.tooltip) },
        React.createElement("strong", null, timestamp),
        React.createElement(HorizontalGroup, null,
            React.createElement("div", null,
                React.createElement(SeriesIcon, { color: seriesColor }),
                React.createElement("span", { className: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n              white-space: nowrap;\n              padding-left: ", ";\n            "], ["\n              white-space: nowrap;\n              padding-left: ", ";\n            "])), theme.spacing.xs) }, displayName)),
            displayValue && React.createElement(FormattedValueDisplay, { value: displayValue }))));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=GraphContextMenu.js.map